import { moduleProviderFactory } from "core/providers";
import { FacilityOrderNewFlowOrderSummary } from "application/facility-order-new-flow-order-summary/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
					{
						name: "master.app.main.facility-order.facility-order-new-flow.order-summary",
						pattern: "/:id/new-flow/order-summary",
						authorization: "facilityOrderSection.update",
						component: FacilityOrderNewFlowOrderSummary,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.ORDER_SUMMARY",
									route: 'master.app.main.facility-order.facility-order-new-flow.order-summary'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.list",
						},
					}
                ]
            }
        ],
		menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.facility-order-new-flow.list",
						order: 2,
					}
				]
			},
        ]
    });
})();
